import "bootstrap";

import Swiper from 'swiper';
window.Swiper = Swiper;

import GLightbox from 'glightbox';
window.GLightbox = GLightbox;

import Swal from 'sweetalert2'
window.Swal = Swal;